import * as yup from 'yup';
import { createI18nError } from 'utils/translateError';
import { isEmojiComponent } from './emoji.utils';

const atLeastOneLetter = /\p{L}/u;

const allowedChars =
  /^[\p{L}\p{M}\p{N}\p{Zs}\t\n\r.,\-+()@"!^:;_«»/*=&#%'’?—–―؛،؟۔。、「」『』։（）？！।॥]+$/u;

export const commentSchema = yup
  .string()
  .transform((v) => v?.trim() || undefined)
  .min(10, 'validationErrors.comment.min')
  .test(
    'max-length-inclusive',
    'validationErrors.comment.max',
    function maxLengthInclusive(value) {
      if (!value) return true;

      if (value.length > 800) {
        return this.createError({
          message: 'validationErrors.comment.max',
          path: this.path,
        });
      }

      return true;
    },
  )
  .matches(atLeastOneLetter, 'validationErrors.comment.atLeastOneLetter')
  .test(
    'no-invalid-symbols',
    'validationErrors.comment.invalidChar',
    function validateSymbols(value) {
      if (!value) return true;

      const invalidChar = [...value].find(
        (char) => !allowedChars.test(char) && !isEmojiComponent(char),
      );

      if (invalidChar) {
        return createI18nError(this, 'validationErrors.comment.invalidChar', {
          symbol: invalidChar,
        });
      }

      return true;
    },
  );
